<template>
  <div>
    <div class="bottom-form" v-bind:class="{'active' : openform.open}">
      <div class="container">
        <h4 v-on:click="closeform(openform.open)" class="c-text-footer">Dowiedz się więcej u Doradcy!
          <img src="@/assets/images/elem/arrow-white-up.png">
        </h4>
        <div class="c-footer_form" v-if="openform.open && !message">
          <div class="c-form-row c-form-row-many">

            <div class="c-form-item">
              <label>
                Imię
                <br />
                <span class="text-error" v-if="errors.first_name && errors.first_name.errors">
                  {{ errors.first_name.message }}
                  <br>
                </span>
                <div class="c-form-inputWrap">
                  <input type="text" value="" v-model="formData.first_name">
                </div>
              </label>
            </div>

            <div class="c-form-item">
              <label>
                Nazwisko
                <br />
                <span class="text-error" v-if="errors.last_name && errors.last_name.errors">
                  {{ errors.last_name.message }}
                  <br>
                </span>
                <div class="c-form-inputWrap">
                  <input type="text" value="" v-model="formData.last_name">
                </div>
              </label>
            </div>

            <div class="c-form-item">
              <label>
                Adres e-mail
                <br />
                <span class="text-error" v-if="errors.email && errors.email.errors">
                  {{ errors.email.message }}
                  <br>
                </span>
                <div class="c-form-inputWrap">
                  <input type="text" value="" v-model="formData.email">
                </div>
              </label>
            </div>

            <div class="c-form-item">
              <label>
                Numer telefonu
                <br />
                <span class="text-error" v-if="errors.phone_number && errors.phone_number.errors">
                  {{ errors.phone_number.message }}
                  <br>
                </span>
                <div class="c-form-inputWrap">
                  <input type="text" value="" v-model="formData.phone_number" maxlength="9" minlength="9">
                </div>
              </label>
            </div>
          </div>

          <label>
            Dodatkowa wiadomość
            <br />
            <textarea name="description" id="description" v-model="changedesc.desc"></textarea>
          </label>
          <p>
            <small>
              Aby móc przetwarzać Państwa dane w celu przesyłania Państwu openformacji dotyczących promocji, akcji marketingowych, organizowanych wydarzeń w sprawie naszej działalności oraz oferowanych przez nas produktów i usług za pośrednictwem
              wskazanych poniżej kanałów komunikacji, prosimy Państwa o wskazanie preferowanych form komunikacji z Państwem poprzez wyrażenie poniżej wskazanych zgód.
              W każdej chwili mogą Państwo cofnąć zgodę na przetwarzanie danych osobowych. Cofnięcie zgody nie wpłynie jednak na zgodność z prawem przetwarzania przez nas danych osobowych przed wycofaniem zgody.
            </small>
          </p>
          <p>
            <small>
              Wyrażam zgodę na przetwarzanie moich danych osobowych w postaci adresu e-mail lub numeru telefonu (w zależności od wybranego kanału komunikacji) przez Porsche Inter Auto Polska Sp. z o.o. ("Porsche") dla celów marketingowych związanych z
              przesyłaniem/przekazywaniem przez Porsche spersonalizowanych openformacji handlowo-marketingowych dotyczących produktów i usług oferowanych przez Porsche, za pośrednictwem:
            </small>
          </p>

          <label>
            <input type="checkbox" name="accept-email9" value="" v-model="formData['accept-email9']" true-value="1" false-value="0"> Email
          </label>

          <label>
            <input type="checkbox" name="accept-phone9" value="" v-model="formData['accept-phone9']" true-value="1" false-value="0"> Telefon
          </label>

          <p>
            <small>
              Administratorem Państwa danych osobowych jest spółka Porsche Inter Auto Polska Sp. z o.o. z siedzibą w Warszawie (01-304) przy ul. Połczyńskiej 118a, zarejestrowana w Sądzie Rejonowym dla m.st. Warszawy, XIII Wydział Gospodarczy Krajowego
              Rejestru Sądowego, KRS 0000108213. Mogą się Państwo z nami skontaktować przy pomocy numeru telefonu +48 22 223 15 15 oraz adresu e-mail: rodo@porscheinterauto.pl.
              <span v-if="acceptToggle">openformujemy, że podane przez Państwa dane będziemy przetwarzać w celu obsługi Państwa zapytania, w tym w celu kontaktu z Państwem w tym zakresie. Będziemy przetwarzać Państwa dane osobowe także w innych celach,
                jeśli wyrażą na to Państwo odrębną zgodę. Podanie przez Państwa danych osobowych jest dobrowolne. Przysługuje Państwu prawo do żądania od nas dostępu do swoich danych osobowych, prawo do ich sprostowania, usunięcia, ograniczenia
                przetwarzania, prawo do przenoszenia danych a także prawo do sprzeciwu wobec przetwarzania przez nas Państwa danych osobowych. Więcej na ten temat przeczytają Państwo w naszej Polityce Prywatności (http://www.porscheinterauto.pl/rodo).</span>
                <br>
                <strong class="pointer" v-on:click="acceptToggle = !acceptToggle" v-if="!acceptToggle">Rozwiń</strong>
                <strong class="pointer" v-on:click="acceptToggle = !acceptToggle" v-if="acceptToggle">Zwiń</strong>
              </small>
            </p>

            <div class="c-btn-wrap">
              <button class="c-btn" v-on:click="sendForm()" v-if="!send">Wyślij</button>
            </div>

            <div class="c-footer-info">
              <b>Audi Kraków Zakopiańska</b><br>
              Zakopiańska 169A, 30-435 Kraków<br>
              <a href="tel:+48 12 363 19 80 ">tel.: +48 12 363 19 80 </a> <a href="mailto:audi.krakow@porscheinterauto.pl"> e-mail: audi.krakow@porscheinterauto.pl</a><br>
              <a href="http://www.audikrakow.pl/">www.audikrakow.pl</a><br>

            </div>

          </div>
          <div v-if="message">
            <h2 class="text-center successform" v-html="message"></h2>
          </div>
        </div>
      </div>
    </div>
  </template>

<script type="text/javascript">
import { mapState } from 'vuex'
// import this.$http from 'this.$http'
export default {
  name: 'contactForm',
  data () {
    return {
      message: false,
      formUrl: 'https://lms-api.activemotors.pl/send/',
      formData: {
        department_id: 1,
        dealer_id: 33,
        origin_id: 11,
        ip: '85.221.212.38',
        url: window.location.href,
        campaign_id: 955,
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        description: '',
        'accept-phone9': 0,
        'accept-email9': 0
      },
      acceptToggle: false,
      errors: {},
      send: false
      // bottomForm: false,
    }
  },
  computed: {
    ...mapState({
      openform: 'openform',
      changedesc: 'changedesc'
    })
  },
  watch: {
    getSelectedOffer: {
      handler: function () {
        this.formData.description = this.getSelectedOffer
      },
      deep: true
    },
    'changedesc.desc': {
      handler: function () {
        this.formData.description = this.changedesc.desc
      },
      deep: true
    }
  },
  validate: {
    rules: {
      first_name: {
        required: true
      },
      last_name: {
        required: true
      },
      email: {
        requireGroup: 'd',
        email: true
      },
      phone_number: {
        requireGroup: 'd',
        phone: true
      }
    },
    messages: {
      first_name: {
        required: 'To pole jest wymagane!'
      },
      last_name: {
        required: 'To pole jest wymagane!'
      },
      email: {
        requireGroup: 'To pole jest wymagane!',
        email: 'Błędny adres E-mail'
      },
      phone_number: {
        requireGroup: 'To pole jest wymagane!',
        phone: 'Błędny numer telefonu'
      }
    }
  },
  methods: {
    eventChild: function () {
    },
    closeform (openValue) {
      gtag('event', 'Otworzenie i zamknięcie formularza')
      openValue = !openValue
      this.$store.dispatch('openForm', { data: openValue })
      // this.$store.dispatch('changedesc', {data: ''});
    },
    sendForm () {
      gtag('event', 'Klikniecie wyślij formularz')
      var that = this
      this.errors = {}
      this.errors = this.$vaLittle.check(this.formData)
      if (!this.errors.errors) {
        this.send = true
        var form_data = new FormData()

        for (var key in that.formData) {
          form_data.append(key, that.formData[key])
        }
        // this.formData.description = this.changedesc.desc;
        this.$http
          .post(this.formUrl, form_data)
          .then(function (response) {
            that.message = response.data.msg
            gtag('event', 'Wysłanie formularza')
            // var s = 1e13 * (Math.random() + '')
            // var n = document.createElement('span')
            // n.innerHTML = '<iframe src="https://9856777.fls.doubleclick.net/activityi;src=9856777;type=lead-0;cat=pia-a00;u5=' + that.formData.phone_number + ';u7=' + that.formData.dealer_id +
            // ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' + s + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>'
            // document.body.insertBefore(n, document.body.firstChild)
          }).catch(
            () => {
              window.alert(
                'Błąd wysyłania zgłoszenia. Sprawdź swoje połączenie z internetem'
              )
            })
      }
    }
  },
  mounted () {
    // track phone numbers click
    document.querySelectorAll('a[href^=tel').forEach(function (e) {
      e.addEventListener('click', function () {
        gtag('event', 'Kliknięcie w numer telefonu')
        // var axel = Math.random() + ''
        // var a = axel * 10000000000000
        // var p = document.createElement('span')
        // p.innerHTML = '<img src="https://ad.doubleclick.net/ddm/activity/src=9856777;type=lead-0;cat=pia-a000;u1=' + window.location.href + ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=' + a +
        //     '?" width="1" height="1" alt=""/>'
        // document.body.appendChild(p)
      })
    })
  }
}
</script>

    <style scoped>
    .pointer{
      cursor: pointer;
    }
    small{
      font-size: 12px;
    }
    .bottom-form{
      z-index: 999;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: #4a4a4a;
      /* height: 3.5rem; */
      /* padding-top: 1rem; */
      color: #fff;
      transition: opacity .8s;
      z-index:9999999999;
    }
    .bottom-form-wrap{
      max-height: 100vh;
      overflow-y: auto;
    }
    .bottom-form h4{
      color: #fff;
      cursor: pointer;
    }
    .bottom-form h4 img{
      height: 1.5rem;
      width: auto;
      margin-left: 1rem;
      transition: transform 1s;
    }
    .bottom-form.active h4 img{
      transform: scaleY(-1);
    }
    .bottom-form.active{
      /* height: 100%;
      min-height: 700px;
      max-height: 100vh; */
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
    .bottom-form input, .bottom-form textarea{
      color: #fff;
    }
    .bottom-form p{
      margin: .5rem;
    }
    .bottom-form a{
      color: #fff;
    }
    .text-center{
      width: 100%;
      text-align: center;
      display: block;
    }
    .c-footer_form input[type=text], .c-footer_form input[type=number], .c-footer_form input[type=data], .c-footer_form input[type=email], .c-footer_form input[type=tel], .c-footer_form textarea {
      border-radius: 4px;
      background-color: rgba(76,76,76,0);
      border: 1px solid #898989;
      font-family: 'AudiType';
      height: 20px;
      color: #ffffff;
    }
    input[type=text] {
      padding: .75rem 5px;
      width: calc(100% - 10px);
      border: 0;
      border-radius: 4px;
      margin: 0.5rem auto;
    }
    textarea{
      padding: 0.75rem 5px;
      width: 100%;
      border: 0;
      border-radius: 4px;
      margin: 0.5rem 0;
    }
    input[type=checkbox] {
      position: relative;
    }
    input[type=checkbox]::after {
      content: ' ';
      display: block;
      width: 1.1rem;
      height: 1.1rem;
      border-radius: 4px;
      position: absolute;
      top: -2px;
      left: -3px;
      background-color: #fff;
      text-align: center;
    }
    input[type=checkbox]:checked::after {
      background: #bb0a30 url(~@/assets/images/elem/icon-check.svg) 50% 50% no-repeat;
      border: 1px solid #bb0a30;
      background-size: 50%;
    }
    button {
      padding: 0.75rem 2rem;
      border: 0;
      background: #fff;
      border-radius: 4px;
      font-size: 1rem;
      font-weight: bold;
      text-transform: uppercase;
      margin:50px 0;
    }
    .c-btn-wrap{
      display: flex;
      justify-content: center;
    }
    p {
      font-size: 0.75rem;
    }
    .c-text-footer{
      padding:15px 0;
      display: block;
      text-align: center;
    }
    .c-footer_form{
      padding:0 20px;
    }
    .c-text-footer img{
      padding-left:0px;
    }
    .text-error{
      font-size: 14px;
      font-weight: bold;
      color: #f00;
    }
    @media(max-width:960px){
      .bottom-form h4 img[data-v-3c4dec59] {
        margin-left: 0rem;
      }
    }
    @media(max-width:600px){
      .bottom-form.active{
        display: block;
        height: 100%;
        max-height: 100vh;
        overflow: auto;
      }
    }
    </style>
